export const whiteListRequest = [
  "/user/login/sms",
  "/user/login",
  "/user/sms/send_code",
  "/user/sms/verify_code",
  "/user/register",
  "/user/reset_password",
  "/user/exist_phone_number",
  "/user/users/qunfeng/authorize",
  "/user/public/config?key=app_config",
  "/user/verify",
];
